import React from "react"
import PropTypes from "prop-types"
import TextField from "material-ui/TextField"

let saveTimeout
const utils = require("../../helpers/utils")

const propTypes = {
    handleChange: PropTypes.func,
    style: PropTypes.object
}

export default class EmailField extends React.Component {
    constructor(props) {
        super()
        this.state = {
            email: "",
            blurred: false,
            errorText: ""
        }
        this.handleChange = this.handleChange.bind(this)
        this.onFocus = this.onFocus.bind(this)
        this.onBlur = this.onBlur.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                email: nextProps.value
            })
        }
    }

    handleChange(event) {
        const _this = this

        this.setState(
            {
                email: event.target.value
            },
            () => {
                const valid = this.validate()
                //Don't send over every change right away, do it on a timer so that it can be saved server-side by parent
                if (saveTimeout) {
                    clearTimeout(saveTimeout)
                }

                saveTimeout = setTimeout(function() {
                    if (_this.props.handleChange) {
                        _this.props.handleChange(_this.state.email, valid)
                    }
                }, 750)
            }
        )
    }

    validate() {
        const valid = utils.validateEmail(this.state.email)

        //empty email is ok
        if (!valid && !this.state.email && this.state.email.length > 0) {
            if (this.state.blurred) {
                this.setState({
                    errorText: "Invalid Email"
                })
            }
        } else {
            this.setState({
                errorText: ""
            })
        }

        return valid
    }

    onBlur() {
        this.setState(
            {
                blurred: true
            },
            () => {
                this.validate()
            }
        )
    }

    onFocus() {
        this.refs.field.input.select()
    }

    render() {
        return (
            <div className="EmailField" style={this.props.style}>
                <TextField
                    floatingLabelText="Email Address"
                    value={this.state.email}
                    onChange={this.handleChange}
                    ref="field"
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    style={{ width: "100%" }}
                    errorText={this.state.errorText}
                />
            </div>
        )
    }
}

EmailField.propTypes = propTypes
